<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="350px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert dense type="error" v-if="showError">
            Please enter a weight value
          </v-alert>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field v-model.number="weight" type="number" min="0" label="Weight"></v-text-field>
              <v-select v-model="unit" :items="['lb', 'kg']" label="Unit"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="show"> Close </v-btn>
          <v-btn
            v-if="!isAuditorRole"
            :color="buttonState.color"
            @click="buttonState.action"
            class="white--text"
          >
            {{ buttonState.name }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    isAuditorRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      selectedId: "",
      showError: false,
      weight: null,
      unit: 'lb'
    };
  },
  computed: {
    buttonState() {
      let state = "";
      if (!this.selectedId) {
        state = {
          name: "save",
          action: this.save,
          color: "#259647",
        };
      } else {
        state = {
          name: "update",
          action: this.update,
          color: "blue darken-1",
        };
      }
      return state;
    },
  },
  methods: {
    show() {
      this.dialog = !this.dialog;
      this.clear();
    },
    save() {
      if (!this.weight && this.weight !== 0) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }
      const data = {
        date: new Date(),
        type: 'weight',
        weight: this.weight,
        unit: this.unit
      };

      this.$emit("save-item", data);
      this.show();
    },
    update() {
      if (!this.weight && this.weight !== 0) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }
      const data = {
        type: 'weight',
        weight: this.weight,
        unit: this.unit
      };

      this.$emit("update-item", data);
      this.show();
    },
    populateData(data) {
      this.selectedId = data._id;
      this.weight = data.weight;
      this.unit = data.unit || 'lb';
    },
    clear() {
      this.selectedId = null;
      this.weight = null;
      this.unit = 'lb';
    },
  },
};
</script>

